import { EnvelopeIcon, HeartIcon } from '@heroicons/react/24/outline';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { Rocket } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FaGithub className="text-lg" />, name: "GitHub", url: "https://github.com/BoubaAhmed" },
    { icon: <FaLinkedin className="text-lg" />, name: "LinkedIn", url: "https://www.linkedin.com/in/ahmed-bouba-861b91231/" },
    { icon: <FaTwitter className="text-lg" />, name: "Twitter", url: "https://twitter.com" },
  ];

  const quickLinks = [
    { name: "Home", url: "#home" },
    { name: "Projects", url: "#projects" },
    { name: "Contact", url: "#contact" },
    { name: "Skills", url: "#skills" },
    { name: "About", url: "#about" },
  ];

  return (
    <footer className="bg-white dark:bg-black border-t border-gray-200 dark:border-gray-800">
      <div className="container mx-auto px-4 max-w-7xl py-12">
        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
          <div className='flex flex-col items-center md:items-start justify-center md:justify-start gap-3 text-center md:text-left'>
            {/* The Logo/Brand Section */}
            <div className="flex items-center gap-2">
              <div className="text-indigo-600 dark:text-indigo-400">
                <Rocket size={24} />
              </div>
              <a
                href="/"
                className="text-gray-900 dark:text-white text-lg font-medium tracking-wide"
                style={{ fontFamily: "Playwrite PL, cursive" }}
              >
                Bouba<span className="text-indigo-600 dark:text-indigo-400">.Dev</span>
              </a>
            </div>

            {/* Copyright Text */}
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              &copy; {currentYear} Bouba Ahmed. All rights reserved.
            </p>
          </div>
          <div className="flex flex-col items-center justify-center gap-3">
            {/* Location / Heart Section */}
            <div className="flex items-center gap-1 text-sm text-gray-600 dark:text-gray-400">
              <span>Made with</span>
              <HeartIcon className="h-3 w-3 text-rose-500 animate-pulse" />
              <span>in Morocco</span>
            </div>

            {/* Links Section */}
            <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              {quickLinks.map((link, index) => (
                <li key={index} className="flex items-center">
                  <a
                    href={link.url}
                    className="text-sm text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className='flex flex-col justify-end gap-3'>
            <a
              href="mailto:ahmedbouuba@gmail.com"
              className="flex items-center text-sm gap-1 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            >
              <EnvelopeIcon className="h-4 w-4" />
              <span>ahmedbouuba@gmail.com</span>
            </a>
            <div className="flex justify-center md:justify-end gap-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  aria-label={link.name}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;